<template lang="pug">
  include /mixins
  span
    slot(
      :needConvert='needConvert'
      :convertedPrice='convertedPrice'
      :nationalCurrencySymbol='nationalCurrencySymbol'
    )
      +b.P.ds-caption--size_xs.--medium.--color_text-8(v-if="needConvert && !isLoad")
        span {{ _("приблизительно") }} &nbsp;
        +b.ds-caption.--appearance_nowrap.--color_text-8.js-price-view.SPAN(
          :data-price="convertedPrice"
          :data-symbol="nationalCurrencySymbol"
        )
</template>

<script>
import { currencyConvertResource } from '@api/vendor.service'

import roundPrices from '@utils/intl'

export default {
  props: {
    siteCurrency: {
      type: String,
    },
    nationalCurrency: {
      type: String,
    },
    nationalCurrencySymbol: {
      type: String,
    },
    price: {
      type: [Number, String],
    },
  },

  data() {
    return {
      convertedPrice: null,
      isLoad: false,
    }
  },

  computed: {
    needConvert() {
      if (this.siteCurrency.toUpperCase() !== this.nationalCurrency.toUpperCase()) {
        return true
      }

      return false
    },
  },

  created() {
    if (this.needConvert) {
      this.getData()
    }
  },

  methods: {
    async getData() {
      this.isLoad = true

      const formdata = {
        from_currency: this.siteCurrency,
        to_currency: this.nationalCurrency,
        value: this.price,
      }

      const { data } = await currencyConvertResource.execute({}, formdata)

      this.convertedPrice = data.value

      this.isLoad = false

      await this.$nextTick()

      roundPrices()
    },
  },
}
</script>
